import React, { Component } from "react";
import { setLotDetails, setTotalSteps, getBasicLotDetails } from "./redux/actions/lot";
import { connect } from "react-redux";
import PickupFormView from "./views/PickupFormView";
import InfoHelpView from "./views/InfoHelpView";
import ViewSwitcher from "./components/ViewSwitcher";
import { goToView } from "./redux/actions/ui";
import { setInfoHelpPage } from "./redux/actions/infoHelp";
import { getIdFromUrl } from "./utils/url";
import "./App.css";
import locale from "./utils/locale";
import Notification from "./containers/Notification";

class App extends Component {
  componentWillMount() {
    const urlObj = getIdFromUrl();
    let id;
    if (urlObj.id) {
      if(urlObj.id==="donation"){
        this.props.setTotalSteps(4);
        id = urlObj.parse_url[urlObj.parse_url.length-2];
      }else{
        id = urlObj.id
      }
    }
    if (id) {
      this.props.setLotDetails({uuid:id});
      this.props.getBasicLotDetails(id);
    }
  }

  render() {
    const { activeView } = this.props;
    return (
      <div className="App">
        <Notification/>
        <ViewSwitcher activeView={activeView}>
          <PickupFormView name="PickupFormView" />
          <InfoHelpView name="InfoHelpView" />
        </ViewSwitcher>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  activeView: state.ui.activeView,
  warning: state.ui.apiError
});
const mapDispatchToProps = { setLotDetails, setInfoHelpPage, goToView, setTotalSteps, getBasicLotDetails };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/App.js